import type { RouteObject } from "react-router-dom";
import { BomHomePage } from "./pages/BomHomePage";
import { BomFamilyListPage } from "./pages/BomFamilyListPage";
import { BomFamilyCreatePage } from "./pages/BomFamilyCreatePage";
import { BomFamilyDetailPage } from "./pages/BomFamilyDetailPage";
import { BomRevisionEditorPage } from "./pages/BomRevisionEditorPage";
import { BomOperationAllocationPage } from "./pages/BomOperationAllocationPage";
import { BomFamiliesHelpPage } from "./pages/help/BomFamiliesHelpPage";
import { BomFamiliesCreateHelpPage } from "./pages/help/BomFamiliesCreateHelpPage";
import { BomFamiliesDetailHelpPage } from "./pages/help/BomFamiliesDetailHelpPage";
import { BomRevisionsHelpPage } from "./pages/help/BomRevisionsHelpPage";
import { BomAllocationsHelpPage } from "./pages/help/BomAllocationsHelpPage";

/**
 * ADR-072 Rule FMS-01/FMS-03: این آرایه در router.tsx مرکزی spread می‌شود.
 * هیچ importی از features دیگر اینجا مجاز نیست.
 */
export const bomRoutes: RouteObject[] = [
  {
    path: "bom",
    element: <BomHomePage />,
  },
  {
    path: "bom/allocations",
    element: <BomOperationAllocationPage />,
  },
  {
    path: "bom/families",
    element: <BomFamilyListPage />,
  },
  {
    path: "bom/families/create",
    element: <BomFamilyCreatePage />,
  },
  {
    path: "bom/families/:id",
    element: <BomFamilyDetailPage />,
  },
  {
    path: "bom/revisions/:id",
    element: <BomRevisionEditorPage />,
  },
  {
    path: "help/bom/families",
    element: <BomFamiliesHelpPage />,
  },
  {
    path: "help/bom/families/create",
    element: <BomFamiliesCreateHelpPage />,
  },
  {
    path: "help/bom/families/detail",
    element: <BomFamiliesDetailHelpPage />,
  },
  {
    path: "help/bom/revisions",
    element: <BomRevisionsHelpPage />,
  },
  {
    path: "help/bom/allocations",
    element: <BomAllocationsHelpPage />,
  },
];
